// extracted by mini-css-extract-plugin
export default {"container":"PieGraph_container__u9WsD","containerSmall":"PieGraph_containerSmall__h6D1W","containerLarge":"PieGraph_containerLarge__HfHLZ","yearLabel":"PieGraph_yearLabel__gyki8"};